import React from 'react';
import { useTranslation } from 'react-i18next';
import Images from '../assets/AllImages';

const SwimmingProgram = () => {
    const { t } = useTranslation();

    const swimmingLevels = [
        {
            title: t("swimming.levels.level1.title"),
            age: t("swimming.levels.level1.age"),
            features: t("swimming.levels.level1.features", { returnObjects: true }),
            description: t("swimming.levels.level1.description"),
            image: "./Images/une-mundem.jpg",
            color: "#FF6B6B",
            gradient: "linear-gradient(135deg, #FF6B6B 0%, #ff5252 100%)"
        },
        {
            title: t("swimming.levels.level2.title"),
            age: t("swimming.levels.level2.age"),
            features: t("swimming.levels.level2.features", { returnObjects: true }),
            description: t("swimming.levels.level2.description"),
            image: "./Images/preeschool.jpg",
            color: "#4ECDC4",
            gradient: "linear-gradient(135deg, #4ECDC4 0%, #26a69a 100%)"
        },
        {
            title: t("swimming.levels.level3.title"),
            age: t("swimming.levels.level3.age"),
            features: t("swimming.levels.level3.features", { returnObjects: true }),
            description: t("swimming.levels.level3.description"),
            image: "./Images/1-10 vjec.jpg",
            color: "#45B7D1",
            gradient: "linear-gradient(135deg, #45B7D1 0%, #2196F3 100%)"
        },
        {
            title: t("swimming.levels.level4.title"),
            age: t("swimming.levels.level4.age"),
            features: t("swimming.levels.level4.features", { returnObjects: true }),
            description: t("swimming.levels.level4.description"),
            image: "./Images/pro.jpg",
            color: "#96CEB4",
            gradient: "linear-gradient(135deg, #96CEB4 0%, #4CAF50 100%)"
        },
        {
            title: t("swimming.levels.level5.title"),
            age: t("swimming.levels.level5.age"),
            features: t("swimming.levels.level5.features", { returnObjects: true }),
            description: t("swimming.levels.level5.description"),
            image: "./Images/SENIOR.jpg",
            color: "#FFEAA7",
            gradient: "linear-gradient(135deg, #FFEAA7 0%, #FFC107 100%)"
        }
    ];

    const LevelCard = ({ level, index }) => {
    return (
            <div className="col-12 col-sm-6 col-lg-4 mb-4">
            <div
                className="h-100 shadow-sm rounded-3 overflow-hidden position-relative swimming-level-card"
                style={{
                    backgroundColor: '#fff',
                    transition: 'all 0.3s ease',
                    border: '1px solid #e9ecef',
                    cursor: 'default',
                }}
                onMouseEnter={(e) => {
                    if (window.innerWidth > 768) {
                        e.currentTarget.style.transform = 'translateY(-5px)';
                        e.currentTarget.style.boxShadow = '0 8px 25px rgba(0,0,0,0.1)';
                        e.currentTarget.style.borderColor = level.color;
                    }
                }}
                onMouseLeave={(e) => {
                    if (window.innerWidth > 768) {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 2px 10px rgba(0,0,0,0.1)';
                        e.currentTarget.style.borderColor = '#e9ecef';
                    }
                }}
            >
                    {/* Image Section */}
                    <div className="position-relative" style={{ height: 'clamp(200px, 30vw, 280px)' }}>
                <img
                            src={level.image}
                            alt={level.title}
                    className="w-100 h-100"
                            style={{ 
                                objectFit: 'cover',
                                backgroundColor: level.color + '20'
                            }}
                            onError={(e) => {
                                e.target.style.backgroundColor = level.color + '20';
                                e.target.style.display = 'flex';
                                e.target.style.alignItems = 'center';
                                e.target.style.justifyContent = 'center';
                                e.target.innerHTML = `<div style="color: ${level.color}; font-size: 3rem;">🏊‍♀️</div>`;
                            }}
                        />
                        {/* Gradient Overlay */}
                        <div 
                            className="position-absolute top-0 start-0 w-100 h-100"
                            style={{ 
                                background: `linear-gradient(135deg, ${level.color}40 0%, ${level.color}80 100%)`,
                                opacity: 0.6
                            }}
                        ></div>
                        
                        {/* Level Number Badge */}
                        <div 
                            className="position-absolute top-0 end-0 m-2 m-md-3 rounded-circle d-flex align-items-center justify-content-center text-white fw-bold"
                            style={{
                                width: 'clamp(40px, 8vw, 50px)',
                                height: 'clamp(40px, 8vw, 50px)',
                                backgroundColor: 'rgba(0,0,0,0.7)',
                                backdropFilter: 'blur(10px)',
                                border: '2px solid rgba(255,255,255,0.5)',
                                fontSize: 'clamp(1.1rem, 3vw, 1.4rem)',
                                fontWeight: 'bold',
                                zIndex: 10
                            }}
                        >
                            {index + 1}
                        </div>
                        
                        {/* Title Overlay */}
                        <div 
                            className="position-absolute bottom-0 start-0 w-100 p-2 p-md-3"
                            style={{
                                background: 'linear-gradient(transparent, rgba(0,0,0,0.8))',
                                backdropFilter: 'blur(2px)'
                            }}
                        >
                            <h4 
                                className="text-white fw-bold mb-1"
                                style={{ 
                                    fontSize: 'clamp(1.1rem, 2.5vw, 1.3rem)',
                                    textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
                                }}
                            >
                                {level.title}
                            </h4>
                            <p 
                                className="text-white mb-0"
                                style={{ 
                                    fontSize: 'clamp(0.8rem, 2vw, 0.9rem)',
                                    opacity: '0.9'
                                }}
                            >
                                {level.age}
                            </p>
                        </div>
                    </div>
                    
                    {/* Content Section */}
                    <div className="p-3 p-md-4">
                        {/* Description */}
                        <p 
                            className="text-muted mb-3"
                            style={{ 
                                fontSize: 'clamp(0.85rem, 2vw, 0.95rem)', 
                                lineHeight: '1.5',
                                minHeight: '60px'
                            }}
                        >
                            {level.description}
                        </p>
                        
                        {/* Features */}
                        <div className="mb-3">
                            {(Array.isArray(level.features) ? level.features : []).map((feature, idx) => (
                                <div
                                    key={idx}
                                    className="d-flex align-items-center mb-2"
                                >
                                    <div
                                        className="me-3 rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                                        style={{
                                            width: '22px',
                                            height: '22px',
                                            backgroundColor: level.color,
                                            color: 'white',
                                            fontSize: '0.8rem',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        ✓
                                    </div>
                                    <span style={{
                                        fontSize: 'clamp(0.8rem, 2vw, 0.9rem)',
                                        lineHeight: '1.4'
                                    }}>
                                        {feature}
                                    </span>
                                </div>
                            ))}
                        </div>
                        
                </div>
            </div>
        </div>
    );
};

    return (
        <>
            {/* Header Section */}
            <main>
                <div className="container-fluid bg-primary py-4 py-md-5 position-relative overflow-hidden">
                    {/* Background Pattern */}
                    <div 
                        className="position-absolute top-0 end-0 d-none d-md-block"
                        style={{
                            width: '200px',
                            height: '200px',
                            background: 'rgba(255,255,255,0.1)',
                            borderRadius: '50%',
                            transform: 'translate(100px, -100px)'
                        }}
                    ></div>
                    <div 
                        className="position-absolute bottom-0 start-0 d-none d-md-block"
                        style={{
                            width: '150px',
                            height: '150px',
                            background: 'rgba(255,255,255,0.1)',
                            borderRadius: '50%',
                            transform: 'translate(-75px, 75px)'
                        }}
                    ></div>
                    
                    <div className="row justify-content-center position-relative">
                        <div className="col-12 px-3 px-md-5 text-center">
                            <h1 
                                className="text-white fw-bold mb-4" 
                                style={{ 
                                    fontSize: 'clamp(2rem, 5vw, 2.8rem)', 
                                    textShadow: '2px 2px 8px rgba(0,0,0,0.3)',
                                    letterSpacing: '1px'
                                }}
                            >
                                {t("swimming.title")}
                            </h1>
                            <p 
                                className="text-white mb-4 mx-auto" 
                                style={{ 
                                    fontSize: 'clamp(1rem, 2.5vw, 1.2rem)', 
                                    lineHeight: '1.7', 
                                    opacity: 0.9,
                                    maxWidth: '900px',
                                    fontWeight: '400'
                                }}
                            >
                                {t("swimming.description")}
                            </p>
                            <p 
                                className="text-white mx-auto" 
                                style={{ 
                                    fontSize: 'clamp(0.9rem, 2vw, 1rem)', 
                                    lineHeight: '1.7', 
                                    opacity: 0.8,
                                    maxWidth: '900px',
                                    fontWeight: '300'
                                }}
                            >
                                {t("swimming.school")}
                            </p>
                        </div>
                    </div>
                </div>
            </main>

            {/* Program Levels Section */}
            <div className="container-fluid py-4 py-md-5" style={{ backgroundColor: '#f8f9fa' }}>
                <div className="container">
                    <div className="row mb-4 mb-md-5">
                        <div className="col-12 text-center">
                            <h2 
                                className="text-primary fw-bold mb-3 mb-md-4"
                                style={{ fontSize: 'clamp(2rem, 5vw, 2.8rem)' }}
                            >
                                {t("swimming.levels.title")}
                            </h2>
                            <div 
                                className="mx-auto"
                                style={{
                                    width: '80px',
                                    height: '4px',
                                    backgroundColor: '#1D3EE3',
                                    borderRadius: '2px'
                                }}
                            ></div>
                        </div>
                            </div>
                    
                    <div className="row g-3 g-md-4">
                        {swimmingLevels.map((level, index) => (
                            <LevelCard key={index} level={level} index={index} />
                        ))}
                    </div>
                </div>
            </div>

            {/* Certificate Section */}
            <div className="container-fluid py-4 py-md-5">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-8">
                            <div className="text-center">
                                <h2 
                                    className="fw-bold mb-4 text-primary"
                                    style={{ fontSize: 'clamp(1.8rem, 4vw, 2.5rem)' }}
                                >
                                    {t("swimming.certificate.title")}
                                </h2>
                                
                                <p 
                                    className="mb-4 text-muted mx-auto"
                                    style={{ 
                                        fontSize: 'clamp(1rem, 2.5vw, 1.2rem)',
                                        lineHeight: '1.6',
                                        maxWidth: '600px'
                                    }}
                                >
                                    {t("swimming.certificate.description")}
                                </p>
                                
                                {/* Certificate Features */}
                                <div className="row justify-content-center mt-5">
                                    <div className="col-12 col-md-10">
                                        <div className="row g-4">
                                            <div className="col-6 col-md-3">
                                                <div className="text-center">
                                                    <div 
                                                        className="d-inline-flex align-items-center justify-content-center mb-3 rounded-circle"
                                                        style={{
                                                            width: 'clamp(45px, 8vw, 60px)',
                                                            height: 'clamp(45px, 8vw, 60px)',
                                                            backgroundColor: '#28a745',
                                                            color: 'white',
                                                            fontSize: 'clamp(1rem, 2.5vw, 1.5rem)',
                                                            boxShadow: '0 4px 15px rgba(40, 167, 69, 0.3)'
                                                        }}
                                                    >
                                                        <i className="fas fa-trophy"></i>
                                                    </div>
                                                    <h6 className="fw-bold text-primary mb-1">{t("swimming.certificate.features.progress")}</h6>
                                                    <small className="text-muted">{t("swimming.certificate.features.progressDesc")}</small>
                                                </div>
                                            </div>
                                            <div className="col-6 col-md-3">
                                                <div className="text-center">
                                                    <div 
                                                        className="d-inline-flex align-items-center justify-content-center mb-3 rounded-circle"
                                                        style={{
                                                            width: 'clamp(45px, 8vw, 60px)',
                                                            height: 'clamp(45px, 8vw, 60px)',
                                                            backgroundColor: '#007bff',
                                                            color: 'white',
                                                            fontSize: 'clamp(1rem, 2.5vw, 1.5rem)',
                                                            boxShadow: '0 4px 15px rgba(0, 123, 255, 0.3)'
                                                        }}
                                                    >
                                                        <i className="fas fa-star"></i>
                                                    </div>
                                                    <h6 className="fw-bold text-primary mb-1">{t("swimming.certificate.features.achievement")}</h6>
                                                    <small className="text-muted">{t("swimming.certificate.features.achievementDesc")}</small>
                                                </div>
                                            </div>
                                            <div className="col-6 col-md-3">
                                                <div className="text-center">
                                                    <div 
                                                        className="d-inline-flex align-items-center justify-content-center mb-3 rounded-circle"
                                                        style={{
                                                            width: 'clamp(45px, 8vw, 60px)',
                                                            height: 'clamp(45px, 8vw, 60px)',
                                                            backgroundColor: '#dc3545',
                                                            color: 'white',
                                                            fontSize: 'clamp(1rem, 2.5vw, 1.5rem)',
                                                            boxShadow: '0 4px 15px rgba(220, 53, 69, 0.3)'
                                                        }}
                                                    >
                                                        <i className="fas fa-heart"></i>
                                                    </div>
                                                    <h6 className="fw-bold text-primary mb-1">{t("swimming.certificate.features.motivation")}</h6>
                                                    <small className="text-muted">{t("swimming.certificate.features.motivationDesc")}</small>
                                                </div>
                                            </div>
                                            <div className="col-6 col-md-3">
                                                <div className="text-center">
                                                    <div 
                                                        className="d-inline-flex align-items-center justify-content-center mb-3 rounded-circle"
                                                        style={{
                                                            width: 'clamp(45px, 8vw, 60px)',
                                                            height: 'clamp(45px, 8vw, 60px)',
                                                            backgroundColor: '#ffc107',
                                                            color: 'white',
                                                            fontSize: 'clamp(1rem, 2.5vw, 1.5rem)',
                                                            boxShadow: '0 4px 15px rgba(255, 193, 7, 0.3)'
                                                        }}
                                                    >
                                                        <i className="fas fa-medal"></i>
                                                    </div>
                                                    <h6 className="fw-bold text-primary mb-1">{t("swimming.certificate.features.recognition")}</h6>
                                                    <small className="text-muted">{t("swimming.certificate.features.recognitionDesc")}</small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Call to Action Section */}
            <div className="container-fluid py-5">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-lg-8">
                            <div className="text-center">
                                <h2 
                                    className="fw-bold mb-4 text-primary"
                                    style={{ fontSize: 'clamp(1.8rem, 4vw, 2.5rem)' }}
                                >
                                    {t("swimming.cta.title")}
                                </h2>
                                
                                <p 
                                    className="mb-5 text-muted mx-auto"
                                    style={{ 
                                        fontSize: 'clamp(1rem, 2.5vw, 1.2rem)',
                                        lineHeight: '1.6',
                                        maxWidth: '600px'
                                    }}
                                >
                                    {t("swimming.cta.description")}
                                </p>
                                
                                <div className="d-flex justify-content-center gap-3 flex-wrap">
                                    <a 
                                        href="/contact"
                                        className="btn btn-primary btn-lg px-5 py-3 fw-bold"
                                        style={{ 
                                            fontSize: '1.1rem',
                                            borderRadius: '8px',
                                            minWidth: '200px',
                                            boxShadow: '0 4px 15px rgba(0, 123, 255, 0.3)',
                                            textDecoration: 'none'
                                        }}
                                    >
                                        {t("swimming.cta.contact")}
                                    </a>
                                    <a
                                        href="tel:048334000"
                                        className="btn btn-success btn-lg px-5 py-3 fw-bold"
                                        style={{ 
                                            fontSize: '1.1rem',
                                            borderRadius: '8px',
                                            minWidth: '200px',
                                            boxShadow: '0 4px 15px rgba(40, 167, 69, 0.3)',
                                            textDecoration: 'none'
                                        }}
                                    >
                                        <i className="fas fa-phone me-2"></i>
                                        {t("swimming.cta.call")}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SwimmingProgram;